import type { Fixture, Outcome } from '@h2h/shared';
import { cn } from '../../../lib/cn';
import { TeamBadge } from '../../TeamBadge';

/** Compact base-pick badge — just the flag/draw symbol in a circle with a
 *  colour-coded ring so the 1X2 anchor is clear without any text label. */
export function BasePickPill({
  outcome,
  fixture,
  homeCode,
  awayCode,
  flag
}: {
  outcome: Outcome;
  fixture: Fixture;
  homeCode: string;
  awayCode: string;
  flag: boolean;
}) {
  const isDraw = outcome === 'DRAW';
  const picked =
    outcome === 'HOME'
      ? { code: homeCode, logo: fixture.homeLogo, name: fixture.homeTeam }
      : outcome === 'AWAY'
        ? { code: awayCode, logo: fixture.awayLogo, name: fixture.awayTeam }
        : null;
  const label = isDraw ? 'Draw' : picked!.name;

  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full p-[3px]',
        isDraw
          ? 'bg-[rgba(227,168,43,0.15)] ring-2 ring-[rgba(227,168,43,0.45)]'
          : 'bg-[rgba(17,179,107,0.1)] ring-2 ring-[rgba(17,179,107,0.4)]'
      )}
      aria-label={`Your pick: ${label}`}
    >
      {isDraw ? (
        <span className="grid h-[26px] w-[26px] place-items-center rounded-full bg-[#E3A82B] text-[13px] font-extrabold leading-none text-white shadow-[0_2px_8px_-2px_rgba(227,168,43,0.5)]">
          =
        </span>
      ) : (
        <TeamBadge
          code={picked!.code}
          logo={picked!.logo}
          name={picked!.name}
          flag={flag}
          sizeClass="h-[26px] w-[26px]"
          roundedClass="rounded-full"
          textClass="text-[7px]"
          className={cn(
            'shadow-[0_2px_8px_-2px_rgba(17,179,107,0.4)]',
            flag ? 'ring-1 ring-inset ring-black/10' : 'border border-black/[0.08]'
          )}
        />
      )}
    </span>
  );
}
